<template>
  <div class="gs-aff-workspace">
    <nav class="gs-aff-workspace__nav" :aria-label="label">
      <button v-for="section in sections" :key="section.value" type="button"
        :class="{ 'is-active': section.value === current, 'has-error': errorSections.includes(section.value) }"
        :aria-current="section.value === current ? 'page' : null"
        @click="$emit('select', section.value)">
        <span>{{ section.title }}</span>
        <small v-if="section.description">{{ section.description }}</small>
      </button>
      <slot name="navigation" />
    </nav>
    <section class="gs-aff-workspace__body" :aria-label="activeTitle">
      <slot />
    </section>
  </div>
</template>
<script>
import '../affiliate-workspace.css';
export default {
  props: {
    sections: { type: Array, default: () => [] },
    current: { type: String, default: '' },
    label: { type: String, default: 'Affiliate sections' },
    errorSections: { type: Array, default: () => [] },
  },
  computed: {
    activeTitle() {
      const active = this.sections.find(section => section.value === this.current);
      return active ? active.title : this.label;
    },
  },
};
</script>
